export default __webpack_public_path__ + "static/media/campFilter.d42b1ee6.svg";